import types from '../../constants';

const initialState = {
  loading: false,
  error: '',
  exercise: {
    selected: '',
    name: '',
    code: '',
  },
  data: [],
  createdId: null,
};

const ExercisesReducers = (state = initialState, action) => {
  switch (action.type) {
    case types.EXERCISE_CREATE_UPDATE:
      return {
        ...state,
        data: action.payload,
      };
    case types.EXERCISE_CREATE_LOADING_START:
      return {
        ...state,
        loading: true,
      };
    case types.EXERCISE_CREATE_LOADING_END:
      return {
        ...state,
        loading: false,
      };
    case types.EXERCISE_CREATE_SCENARIOS_LIST:
      return {
        ...state,
        data: action.payload,
      };
    case types.EXERCISE_CREATE_SELECT_SCENARIO:
      return {
        ...state,
        exercise: {
          ...state.exercise,
          selected: action.payload,
        },
      };
    case types.EXERCISE_CREATE_SET_ERROR:
      return {
        ...state,
        error: action.payload,
      };
    case types.EXERCISE_CREATE_CLEAR_ERROR:
      return {
        ...state,
        error: '',
      };
    case types.EXERCISE_CREATE_CHANGE_FORM:
      const newState = {
        ...state,
      };

      newState.exercise = { ...state.exercise };
      newState.exercise[action.payload.field] = action.payload.value;

      return newState;
    case types.EXERCISE_CREATE_SUCCESS:
      return {
        ...state,
        createdId: action.payload,
      };
    case types.EXERCISE_CREATE_CLEAR:
      return initialState;
    default:
      return state;
  }
};

export default ExercisesReducers;
